import { EErrorPageTypes } from '../../actions/errorPage';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function errorPageReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EErrorPageTypes.Set:
      return {
        ...state,
        showErrorPage: true,
      };

    case EErrorPageTypes.Unset:
      return {
        ...state,
        showErrorPage: false,
      };

    default:
      return state;
  }
}
